import importerActions from 'src/modules/shared/importer/importerActions';
import selectors from 'src/modules/nutritionInformation/importer/nutritionInformationImporterSelectors';
import NutritionInformationService from 'src/modules/nutritionInformation/nutritionInformationService';
import fields from 'src/modules/nutritionInformation/importer/nutritionInformationImporterFields';
import { i18n } from 'src/i18n';

const nutritionInformationImporterActions = importerActions(
  'NUTRITIONINFORMATION_IMPORTER',
  selectors,
  NutritionInformationService.import,
  fields,
  i18n('entities.nutritionInformation.importer.fileName'),
);

export default nutritionInformationImporterActions;